"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

var _handlebars = _interopRequireDefault(require("handlebars"));

var _config = _interopRequireDefault(require("config"));

var _Global = _interopRequireDefault(require("models/Global"));

var _backboneCollectionView = _interopRequireDefault(require("backbone-collectionView"));

var _laddaWrapper = _interopRequireDefault(require("../plugins/ladda/laddaWrapper"));

var _icheck = _interopRequireDefault(require("../plugins/icheck/icheck"));

var _FormViewMixin = _interopRequireDefault(require("./FormViewMixin"));

var _FormFieldView = _interopRequireDefault(require("./FormFieldView"));

var _FormSubmittedPopupView = _interopRequireDefault(require("./FormSubmittedPopupView"));

var _form_separator_view = _interopRequireDefault(require("hbars!../templates/form_separator_view"));

var _form_view = _interopRequireDefault(require("hbars!../templates/form_view"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_handlebars.default.registerPartial('form_view', _form_view.default);

var FormView = _backbone.default.View.extend({
  events: {
    'click .save-action': 'savedClick'
  },
  initialize: function initialize() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.separators = options.separators || [];
    this.rowsView = new _backbone.default.CollectionView({
      collection: this.model.get('included'),
      selectable: false,
      modelView: _FormFieldView.default,
      modelViewOptions: {
        inFormView: true,
        layout: this.model.get('layout'),
        separators: this.separators
      }
    });
    this.formSubmittedPopupView = new _FormSubmittedPopupView.default({
      model: this.model,
      elementId: '#dialog-container',
      parent: this.el
    });
  },
  getParametersFromUrl: function getParametersFromUrl(search) {
    var params = new Proxy(new URLSearchParams(search), {
      get: function get(searchParams, prop) {
        return searchParams.get(prop);
      }
    });
    return params;
  },
  getUTMParamsFromNavigation: function getUTMParamsFromNavigation() {
    return this.getParametersFromUrl(window.location.search);
  },
  getUTMParamsFromSessionStorage: function getUTMParamsFromSessionStorage() {
    var eventId = _Global.default.get('event').get('id');

    var bzQueryString = window.sessionStorage.getItem('bz-query-string-'.concat(eventId));
    return this.getParametersFromUrl(bzQueryString);
  },
  getMergedUTMObject: function getMergedUTMObject() {
    var paramsFromStorage = this.getUTMParamsFromSessionStorage();
    var paramsFromUrl = this.getUTMParamsFromNavigation();
    return {
      utmSource: paramsFromUrl !== null && paramsFromUrl !== void 0 && paramsFromUrl.utm_source ? paramsFromUrl.utm_source : paramsFromStorage === null || paramsFromStorage === void 0 ? void 0 : paramsFromStorage.utm_source,
      utmMedium: paramsFromUrl !== null && paramsFromUrl !== void 0 && paramsFromUrl.utm_medium ? paramsFromUrl.utm_medium : paramsFromStorage === null || paramsFromStorage === void 0 ? void 0 : paramsFromStorage.utm_medium,
      utmCampaign: paramsFromUrl !== null && paramsFromUrl !== void 0 && paramsFromUrl.utm_campaign ? paramsFromUrl.utm_campaign : paramsFromStorage === null || paramsFromStorage === void 0 ? void 0 : paramsFromStorage.utm_campaign,
      utmTerm: paramsFromUrl !== null && paramsFromUrl !== void 0 && paramsFromUrl.utm_term ? paramsFromUrl.utm_term : paramsFromStorage === null || paramsFromStorage === void 0 ? void 0 : paramsFromStorage.utm_term,
      utmContent: paramsFromUrl !== null && paramsFromUrl !== void 0 && paramsFromUrl.utm_content ? paramsFromUrl.utm_content : paramsFromStorage === null || paramsFromStorage === void 0 ? void 0 : paramsFromStorage.utm_content
    };
  },
  setUTMParams: function setUTMParams() {
    var UTM = this.getMergedUTMObject();
    var included = this.model.get('included');
    var keys = Object.keys(UTM);
    keys.forEach(function (key) {
      if (UTM[key]) {
        var model = included.findWhere({
          attributeKey: key
        });
        model && model.set('localValues', UTM[key]);
      }
    });
  },
  remove: function remove() {
    this.rowsView.remove();
    this.formSubmittedPopupView.remove();
    return _backbone.default.View.prototype.remove.call(this);
  },
  savedClick: function savedClick() {
    if (this.model.isAllModelValid(true)) {
      this.ladda && this.ladda.start();
      this.model.save(null, {
        success: _underscore.default.bind(this.onSubmitSuccess, this),
        error: _underscore.default.bind(this.showErrorMessage, this)
      });
    } else {
      this.showErrorMessage(this.model, null, 'Please fix the errors before submitting.');
    }
  },
  onSubmitSuccess: function onSubmitSuccess() {
    var thisView = this;
    this.ladda && this.ladda.success();

    _underscore.default.delay(function () {
      thisView.formSubmittedPopupView.show();

      _backbone.default.trigger('analytics:formSubmitted', 'Bizzabo: ' + (_Global.default.get('event') && _Global.default.get('event').get('name')), thisView.model.get('name') + ' Completed', 'Form Submission');
    }, 1500);
  },
  showErrorMessage: function showErrorMessage(model, err, msg) {
    this.ladda && this.ladda.error();
    msg = _underscore.default.isString(msg) ? msg : 'Could\'nt submit form. Please try again later.';
    var errorElement = this.$('.js-submit-error');
    errorElement.text(msg);
    errorElement.addClass('error-visible').removeClass('error-hidden');

    _underscore.default.delay(function () {
      errorElement.addClass('error-hidden').removeClass('error-visible');
      errorElement.text('');
    }, 4000);
  },
  initLaddaButton: function initLaddaButton() {
    var saveButton = this.$('.save-action');
    saveButton.addClass('ladda-button').attr('data-style', 'slide-up');
    this.ladda = _laddaWrapper.default.create(saveButton[0]);
  },
  organizeBySeparators: function organizeBySeparators() {
    var _this = this;

    var _this$separators = this.separators,
        separators = _this$separators === void 0 ? [] : _this$separators;
    var sortedSeparators = (0, _underscore.default)(separators).sortBy('position');
    sortedSeparators.forEach(function (_ref) {
      var position = _ref.position,
          label = _ref.label;

      if (position > 0) {
        _this.$(".form-fields-holder>li:nth-child(".concat(position, ")")).after((0, _form_separator_view.default)({
          label: label
        }));
      } else {
        _this.$('.form-fields-holder>li:nth-child(1)').before((0, _form_separator_view.default)({
          label: label
        }));
      }
    });
  },
  render: function render() {
    this.$el.html((0, _form_view.default)(this.model.toJSON()));
    this.rowsView.setElement(this.$('.form-fields-holder'));
    this.rowsView.render();
    this.initLaddaButton();
    this.organizeBySeparators();
    this.initValidation({
      attrs: ['legalAgreement', 'additionalTermsConsent'],
      tracking: false,
      handleSave: false
    });
    this.renderForm();
    this.setUTMParams();
    return this;
  }
});

_underscore.default.extend(FormView.prototype, _FormViewMixin.default);

var _default = FormView;
exports.default = _default;